<div id="customParameterContainer" class="custom-field-render-container "
    [ngClass]="{'popup': modalType == 'popup','sidebar': modalType == 'sidebar',}" [class.show]="isModalOpen">
    <div class="custom-field-modal" #customfieldmodal>
        <div class="custom-field-modal-content">
            <div class="custom-field-modal-header">
                <span id="customParameterModalLabel" class="custom-field-modal-title"> </span>
                <!-- <button type="button" class="pull-right btn btn-danger" data-dismiss="modal" aria-label="Close"><span aria-hidden="true" class="fa fa-times"></span></button> -->
                <a id="customParameterCloseBtn" type="button" class="custom-field-modal-close-btn" (click)="closeModal()" aria-label="Close"><span aria-hidden="true"><i class="fa fa-times"></i></span></a>
            </div>
            <div  #vcr class="custom-field-modal-body" style="padding: 3% 4% 3% 4%;">
                <div id="customParameterModalBody">
                    
                </div>
            </div>
            <div id="customParameterModalFooter" class="custom-field-modal-footer">
                <div id="customParameterNote" class="modal-note-messaage"></div>
                <div class="action-btn-wrapper">
                    <div>
                        <litmus-button id="customParameterCloseBtn" class_name="btn-light"
                            text="Cancel"></litmus-button>
                    </div>
                    <div id="customParameterAction"></div>
                </div>
            </div>
        </div>
    </div>
</div>
